/**
 * Return the final path segment for a Firestore-like id/path.
 *
 * @param {unknown} value - Raw contact identifier.
 * @returns {string} Final non-empty segment, or empty string.
 */
function lastSegment(value) {
  const raw = String(value ?? '').trim();
  if (!raw) return '';
  const parts = raw.split('/').filter(Boolean);
  return parts.length ? parts[parts.length - 1] : raw;
}

/**
 * Normalize any contact identifier into a canonical key.
 *
 * @param {unknown} value - Raw contact identifier or path.
 * @returns {string|null} Canonical contact key, or null when absent.
 */
export function normalizeContactKey(value) {
  const key = lastSegment(value);
  return key ? key : null;
}

/**
 * Build a de-duplicated candidate list with raw and normalized ids.
 *
 * @param {Array<unknown>} values - Contact candidates.
 * @returns {string[]} Unique candidate ids.
 */
export function buildContactCandidates(values = []) {
  const out = new Set();
  values.forEach((value) => {
    if (value == null) return;
    const raw = String(value).trim();
    if (!raw) return;
    out.add(raw);
    const normalized = normalizeContactKey(raw);
    if (normalized) out.add(normalized);
  });
  return Array.from(out);
}
